import { memo, useMemo, type FC } from 'react';

import { useTableContext } from '../../context.tsx';
import { TableCellContentType } from '../../types.ts';
import { Cell } from '../Cell/index.tsx';
import { Row } from '../Row/index.tsx';
import { LoaderBar } from './styled.ts';
import type { LoaderProps } from './types.ts';

export const Loader: FC<LoaderProps> = memo(function Loader({ rows = 3, dataTestId }) {
  const { columnCount } = useTableContext();

  const rowsArray = useMemo(() => Array.from({ length: rows }, (_, i) => i), [rows]);
  const columnsArray = useMemo(() => Array.from({ length: columnCount }, (_, i) => i), [columnCount]);

  return rowsArray.map((i) => (
    <Row key={i} dataTestId={dataTestId}>
      {columnsArray.map((j) => (
        <Cell contentType={TableCellContentType.LOADING} key={j}>
          <LoaderBar />
        </Cell>
      ))}
    </Row>
  ));
});
